// Mock data for select fields
export const visitDateOptions = (t) => [
  { value: "before", label: t("CAMPAIGNS_FORM_VISIT_BEFORE") },
  { value: "after", label: t("CAMPAIGNS_FORM_VISIT_AFTER") },
];

// Port options for entry point
export const portOptions = (t) => [
  { value: "JED", label: t("FLIGHTS_MODAL_PORT_JED") },
  { value: "MED", label: t("FLIGHTS_MODAL_PORT_MED") },
];

export const countryOptions = [
  { value: "IR", label: "إيران" },
  { value: "SA", label: "السعودية" },
  { value: "EG", label: "مصر" },
  { value: "JO", label: "الأردن" },
  { value: "AE", label: "الإمارات" },
  { value: "KW", label: "الكويت" },
  { value: "BH", label: "البحرين" },
  { value: "OM", label: "عمان" },
  { value: "QA", label: "قطر" },
  { value: "YE", label: "اليمن" },
  { value: "IQ", label: "العراق" },
  { value: "LB", label: "لبنان" },
  { value: "SY", label: "سوريا" },
  { value: "TR", label: "تركيا" },
  { value: "US", label: "الولايات المتحدة الأمريكية" },
  { value: "UK", label: "المملكة المتحدة" },
];

export const serviceCenterOptions = [
  { value: "مركز خدمة ميدانية 1", label: "مركز خدمة ميدانية 1" },
  { value: "مركز خدمة ميدانية 2", label: "مركز خدمة ميدانية 2" },
  { value: "مركز خدمة ميدانية 3", label: "مركز خدمة ميدانية 3" },
  { value: "مركز خدمة ميدانية 4", label: "مركز خدمة ميدانية 4" },
  { value: "مركز خدمة ميدانية 5", label: "مركز خدمة ميدانية 5" },
  { value: "مركز خدمة ميدانية 6", label: "مركز خدمة ميدانية 6" },
  { value: "مركز خدمة ميدانية 7", label: "مركز خدمة ميدانية 7" },
  { value: "مركز خدمة ميدانية 8", label: "مركز خدمة ميدانية 8" },
  { value: "مركز خدمة ميدانية 9", label: "مركز خدمة ميدانية 9" },
  { value: "مركز خدمة ميدانية 10", label: "مركز خدمة ميدانية 10" },
  { value: "مركز خدمة ميدانية 11", label: "مركز خدمة ميدانية 11" },
  { value: "مركز خدمة ميدانية 12", label: "مركز خدمة ميدانية 12" },
  { value: "مركز خدمة ميدانية 13", label: "مركز خدمة ميدانية 13" },
  { value: "مركز خدمة ميدانية 14", label: "مركز خدمة ميدانية 14" },
  { value: "مركز خدمة ميدانية 15", label: "مركز خدمة ميدانية 15" },
];

// Province/State options (الولاية)
export const provinceOptions = [
  { value: "10", label: "اردبیل" },
  { value: "11", label: "آذربایجان شرقی" },
  { value: "12", label: "آذربایجان غربی" },
  { value: "13", label: "اصفهان" },
  { value: "14", label: "ایلام" },
  { value: "15", label: "کرمانشاه" },
  { value: "16", label: "بوشهر" },
  { value: "17", label: "تهران" },
  { value: "18", label: "چهار محال و بختیاری" },
  { value: "19", label: "خراسان رضوی" },
  { value: "20", label: "خوزستان" },
  { value: "21", label: "زنجان" },
  { value: "22", label: "سمنان" },
  { value: "23", label: "سیستان و بلوچستان" },
  { value: "24", label: "فارس" },
  { value: "25", label: "کردستان" },
  { value: "26", label: "کرمان" },
  { value: "27", label: "کهگیلویه و بویراحمد" },
  { value: "28", label: "گیلان" },
  { value: "29", label: "لرستان" },
  { value: "30", label: "مازندران" },
  { value: "31", label: "مرکزی" },
  { value: "32", label: "هرمزگان" },
  { value: "33", label: "همدان" },
  { value: "34", label: "یزد" },
  { value: "35", label: "قم" },
  { value: "36", label: "کاشان" },
  { value: "37", label: "قزوین" },
  { value: "38", label: "گلستان" },
  { value: "39", label: "خراسان جنوبی" },
  { value: "40", label: "خراسان شمالی" },
  { value: "41", label: "البرز" },
  { value: "48", label: "تهران" },
  { value: "49", label: "تهران" },
  { value: "50", label: "تهران" },
];

// Airline company options (شركة الطيران)
export const airlineOptions = [
  { value: "SV", label: "السعودية (SV)" },
  { value: "XY", label: "ناس (XY)" },
  { value: "F3", label: "ادیل (F3)" },
  { value: "EK", label: "الإماراتية (EK)" },
  { value: "EY", label: "الاتحاد (EY)" },
  { value: "QR", label: "القطرية (QR)" },
  { value: "IR", label: "الإيرانية (IR)" },
  { value: "WY", label: "العمانية (WY)" },
  { value: "MS", label: "المصرية (MS)" },
  { value: "JR", label: "الأردنية (JR)" },
  { value: "MH", label: "المالزية (MH)" },
  { value: "GA", label: "الاندنوسية (GA)" },
  { value: "HC", label: "السنغالية (HC)" },
  { value: "MK", label: "موريشيوس (MK)" },
  { value: "GF", label: "الخليج (GF)" },
];

// Transport method options (الوسيلة)
export const transportMethodOptions = [
  { value: "private_car", label: "سيارة خاصة" },
  { value: "taxi", label: "سيارة اجرة" },
  { value: "train", label: "قطار" },
  { value: "microbus", label: "مايكروباض" },
  { value: "company_car", label: "سيارة الشركة التابعة" },
  { value: "transport_bus", label: "حافلة شركات النقل" },
  { value: "public_car", label: "سيارة نقل عام" },
  { value: "truck", label: "شاحنة" },
  { value: "private_bus", label: "حافلة خاصة" },
];

// Entry port options (المنفذ)
export const entryPortOptions = [
  { value: "JED_AIRPORT", label: "مطار الملك عبد العزيز الدولي - جده" },
  { value: "MED_AIRPORT", label: "مطار الأمير محمد بن عبد العزيز - المدينة" },
  {
    value: "YANBU_AIRPORT",
    label: "مطار الأمير عبد المحسن بن عبد العزيز - ينبع",
  },
  { value: "TAIF_AIRPORT", label: "مطار الطائف" },
  { value: "RIYADH_AIRPORT", label: "مطار الملك خالد - الرياض" },
  { value: "DAMMAM_AIRPORT", label: "مطار الملك فهد - الدمام" },
  { value: "JED_PORT", label: "ميناء جده الإسلامي" },
  { value: "YANBU_PORT", label: "ميناء ينبع التجاري" },
  { value: "LAND_BORDER", label: "مننفذ بري" },
];

// Arrival route options (المسار القدوم)
export const arrivalRouteOptions = [
  { value: "MADINAH", label: "المدينة المنورة" },
  { value: "MADINAH_TRAIN", label: "المدينة المنورة بالقطار" },
  { value: "JEDDAH", label: "جدة" },
  { value: "JEDDAH_TRAIN", label: "جدة بالقطار" },
  { value: "JEDDAH_AIRPORT_TRAIN", label: "مطار جدة بالقطار" },
  { value: "TAIF", label: "الطائف" },
  { value: "YANBU", label: "ينبع" },
  { value: "MAKKAH", label: "مكة المكرمة" },
  { value: "MAKKAH_TRAIN", label: "مكة المكرمة بالقطار" },
  { value: "JEDDAH_AIRPORT", label: "مطار جدة" },
];

// Departure route options (المسار المغادرة)
export const departureRouteOptions = [
  { value: "JEDDAH_AIRPORT", label: "جدة - مطار الملك عبد العزيز" },
  {
    value: "JEDDAH_AIRPORT_TRAIN",
    label: "جدة - مطار الملك عبد العزيز بالقطار",
  },
  { value: "JEDDAH", label: "جدة" },
  { value: "JEDDAH_TRAIN", label: "جدة بالقطار" },
  { value: "MADINAH", label: "المدينة المنورة" },
  { value: "MADINAH_TRAIN", label: "المدينة المنورة بالقطار" },
  { value: "MADINAH_AIRPORT", label: "المدينة - مطار الأمير محمد" },
  { value: "TAIF", label: "الطائف" },
  { value: "YANBU", label: "ينبع" },
  { value: "MAKKAH", label: "مكة المكرمة" },
  { value: "MAKKAH_TRAIN", label: "مكة المكرمة بالقطار" },
  { value: "LAND_BORDER", label: "حد بري" },
];

// Direction options (الاتجاه)
export const directionOptions = [
  { value: "MADINAH", label: "المدينة المنورة" },
  { value: "JEDDAH", label: "جدة" },
  { value: "MAKKAH", label: "مكة المكرمة" },
  { value: "TAIF", label: "الطائف" },
  { value: "YANBU", label: "ينبع" },
];

// Arabic day options (أيام الأسبوع)
export const arabicDayOptions = [
  { value: "الأحد", label: "الأحد" },
  { value: "الإثنين", label: "الإثنين" },
  { value: "الثلاثاء", label: "الثلاثاء" },
  { value: "الأربعاء", label: "الأربعاء" },
  { value: "الخميس", label: "الخميس" },
  { value: "الجمعة", label: "الجمعة" },
  { value: "السبت", label: "السبت" },
];

export const countryCodeMap = {
  1: "US",
  20: "EG",
  27: "ZA",
  30: "GR",
  31: "NL",
  32: "BE",
  33: "FR",
  34: "ES",
  36: "HU",
  39: "IT",
  40: "RO",
  41: "CH",
  43: "AT",
  44: "GB",
  45: "DK",
  46: "SE",
  47: "NO",
  48: "PL",
  49: "DE",
  51: "PE",
  52: "MX",
  53: "CU",
  54: "AR",
  55: "BR",
  56: "CL",
  57: "CO",
  58: "VE",
  60: "MY",
  61: "AU",
  62: "ID",
  63: "PH",
  64: "NZ",
  65: "SG",
  66: "TH",
  81: "JP",
  82: "KR",
  84: "VN",
  86: "CN",
  90: "TR",
  91: "IN",
  92: "PK",
  93: "AF",
  94: "LK",
  95: "MM",
  98: "IR",
  211: "SS",
  212: "MA",
  213: "DZ",
  216: "TN",
  218: "LY",
  220: "GM",
  221: "SN",
  222: "MR",
  223: "ML",
  224: "GN",
  225: "CI",
  226: "BF",
  227: "NE",
  228: "TG",
  229: "BJ",
  230: "MU",
  231: "LR",
  232: "SL",
  233: "GH",
  234: "NG",
  235: "TD",
  236: "CF",
  237: "CM",
  238: "CV",
  239: "ST",
  240: "GQ",
  241: "GA",
  242: "CG",
  243: "CD",
  244: "AO",
  245: "GW",
  248: "SC",
  249: "SD",
  250: "RW",
  251: "ET",
  252: "SO",
  253: "DJ",
  254: "KE",
  256: "UG",
  257: "BI",
  258: "MZ",
  260: "ZM",
  261: "MG",
  262: "RE",
  263: "ZW",
  265: "MW",
  266: "LS",
  267: "BW",
  284: "VG",
  290: "SH",
  291: "ER",
  297: "AW",
  298: "FO",
  299: "GL",
  340: "VI",
  345: "KY",
  350: "GI",
  351: "PT",
  352: "LU",
  353: "IE",
  354: "IS",
  355: "AL",
  356: "MT",
  357: "CY",
  358: "FI",
  359: "BG",
  370: "LT",
  371: "LV",
  372: "EE",
  373: "MD",
  374: "AM",
  375: "BY",
  376: "AD",
  377: "MC",
  378: "SM",
  380: "UA",
  385: "HR",
  386: "SI",
  387: "BA",
  389: "MK",
  420: "CZ",
  421: "SK",
  423: "LI",
  441: "BM",
  473: "GD",
  500: "FK",
  501: "BZ",
  502: "GT",
  503: "SV",
  504: "HN",
  505: "NI",
  506: "CR",
  507: "PA",
  508: "PM",
  509: "HT",
  550: "XK",
  590: "GP",
  591: "BO",
  592: "GY",
  593: "EC",
  594: "GF",
  595: "PY",
  597: "SR",
  598: "UY",
  649: "TC",
  664: "MS",
  671: "GU",
  673: "BN",
  674: "NR",
  675: "PG",
  676: "TO",
  677: "SB",
  678: "VU",
  679: "FJ",
  680: "PW",
  681: "WF",
  682: "CK",
  683: "NU",
  684: "AS",
  685: "WS",
  686: "KI",
  687: "NC",
  688: "TV",
  689: "PF",
  690: "TK",
  691: "FM",
  692: "MH",
  758: "LC",
  767: "DM",
  784: "VC",
  809: "DO",
  850: "KP",
  852: "HK",
  853: "MO",
  855: "KH",
  856: "LA",
  868: "TT",
  876: "JM",
  880: "BD",
  886: "TW",
  960: "MV",
  961: "LB",
  962: "JO",
  963: "SY",
  964: "IQ",
  965: "KW",
  966: "SA",
  967: "YE",
  968: "OM",
  970: "PS",
  971: "AE",
  972: "PS",
  973: "BH",
  974: "QA",
  975: "BT",
  976: "MN",
  977: "NP",
  992: "TJ",
  993: "TM",
  994: "AZ",
  995: "GE",
  996: "KG",
  998: "UZ",
  999: "SS",
  1039: "VA",
  1061: "CX",
  1112: "CA",
  1242: "BS",
  1246: "BB",
  1787: "PR",
  2061: "CC",
  2551: "TZ",
  2641: "AI",
  2642: "NA",
  2681: "AG",
  2682: "AG",
  2683: "SZ",
  2691: "KM",
  2692: "YT",
  3812: "YU",
  5962: "MQ",
  6701: "TL",
  6702: "MP",
  6721: "AQ",
  6722: "NF",
  7001: "KZ",
  7002: "RU",
  9651: "KW",
  9681: "OM",
  9711: "AE",
  9731: "BH",
  9741: "QA",
  9800: "MG",
  9801: "RS",
  9802: "XX",
  9803: "PS",
  9804: "PS",
  9805: "BH",
  9806: "ME",
  9807: "CZ",
  9808: "RU",
  9809: "KN",
  9810: "PS",
  9811: "PS",
  9812: "PS",
  9998: "XX",
  9999: "XX",
};


export const arrivalPortMap = {
  makkah: "JED",
  MADINAH: "MED",
}